module.exports = __webpack_public_path__ + "158759dcf5248781e7d714962cc7585a.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/flat/purple@2x.png
// module id = 292
// module chunks = 0